import React from "react";
import config from "../../config/config";
import { Avatar } from "antd";

const defaultAvatarUrl = "https://apps.ketrics.com/img/avatar.png";

interface IUserAvatarState {}

interface IUserAvatarProps {
  user: IUser;
  size: number;
}

class UserAvatar extends React.Component<IUserAvatarProps, IUserAvatarState> {
  static defaultProps = {
    size: 50
  };

  render() {
    const { user, size } = this.props;

    let url = defaultAvatarUrl;
    if (user.avatarUrl) {
      url = `${config.cdn.URL}/accounts/${this.props.user.accountId}/users/${
        this.props.user.userId
      }/avatar.jpg?timestamp=${Date.now()}`;
    }

    return <Avatar src={url} size={size} alt={user.userId} />;
  }
}

export default UserAvatar;
